import { useCanAccessUsersResource } from '../../auth/useCanAccessUsersResource';
import {
  AssignmentEmpty,
  type AssignmentEmptyProps,
} from '../Moonstar/AssignmentEmpty';

/**
 * Empty state of the lists that assign users to something (role users, user group members): the shared
 * `AssignmentEmpty`, with the link only for users with users access.
 */
export const UserAssignmentEmpty = (
  props: Omit<AssignmentEmptyProps, 'showLink'>
) => {
  const canAccessUsers = useCanAccessUsersResource();

  return <AssignmentEmpty {...props} showLink={canAccessUsers} />;
};
